export enum SizeType {
  s = "s",
  m = "m",
  l = "l",
}
